import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Briefcase,
  MessageSquareText,
  Shield,
  Scale,
  ShieldAlert,
  Ban,
  SlidersHorizontal,
  Building2,
  KeyRound,
  Settings,
  Flag,
  Mail,
  Radio,
  Plug,
  BarChart3,
  ScrollText,
  Bell,
  Siren,
  Search,
  ArrowRight,
  Inbox,
  Eye,
  Clock,
  UserRound,
  type LucideProps,
} from 'lucide-react';
import { Icon } from '@beatq/ui';

const BY_SCREEN: Record<string, LucideIcon> = {
  'SCR-ADM-002': LayoutDashboard,
  'SCR-ADM-003': Briefcase,
  'SCR-ADM-006': MessageSquareText,
  'SCR-ADM-022': Inbox,
  'SCR-ADM-024': Shield,
  'SCR-ADM-027': Scale,
  'SCR-ADM-028': ShieldAlert,
  'SCR-ADM-030': Ban,
  'SCR-ADM-031': SlidersHorizontal,
  'SCR-ADM-034': Building2,
  'SCR-ADM-037': KeyRound,
  'SCR-ADM-038': Settings,
  'SCR-ADM-039': Flag,
  'SCR-ADM-040': Mail,
  'SCR-ADM-041': Radio,
  'SCR-ADM-042': Siren,
  'SCR-ADM-043': Plug,
  'SCR-ADM-044': BarChart3,
  'SCR-ADM-045': ScrollText,
  'SCR-ADM-046': Bell,
};

const BY_HREF: Record<string, LucideIcon> = {
  '/admin-dashboard': LayoutDashboard,
  '/case-queue': Briefcase,
  '/macro-management': MessageSquareText,
  '/approval-inbox': Inbox,
  '/moderation-queue': Shield,
  '/moderation-appeals': Scale,
  '/fraud-queue': ShieldAlert,
  '/risk-blocks': Ban,
  '/risk-rules': SlidersHorizontal,
  '/tenant-list': Building2,
  '/platform-users-and-roles': KeyRound,
  '/platform-configuration': Settings,
  '/feature-flags': Flag,
  '/notification-templates': Mail,
  '/broadcast': Radio,
  '/emergency-controls': Siren,
  '/provider-configuration': Plug,
  '/platform-reports': BarChart3,
  '/audit-search': ScrollText,
  '/notification-centre': Bell,
};

export function resolveAdminIcon(opts: { screenId?: string; href?: string }): LucideIcon {
  if (opts.screenId && BY_SCREEN[opts.screenId]) return BY_SCREEN[opts.screenId];
  if (opts.href && BY_HREF[opts.href]) return BY_HREF[opts.href];
  return LayoutDashboard;
}

/** PRM-16 wrapper around a Lucide glyph — never the sole carrier of meaning. */
export function AdminIcon({
  screenId,
  href,
  icon: IconComp,
  label,
  size = 18,
  strokeWidth = 1.75,
  className,
}: {
  screenId?: string;
  href?: string;
  icon?: LucideIcon;
  label?: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  const Comp = IconComp ?? resolveAdminIcon({ screenId, href });
  return (
    <Icon label={label} className={className}>
      <Comp size={size} strokeWidth={strokeWidth} aria-hidden={label ? undefined : true} />
    </Icon>
  );
}

export {
  Search,
  ArrowRight,
  Bell,
  Siren,
  LayoutDashboard,
  Briefcase,
  Shield,
  ShieldAlert,
  Eye,
  Clock,
  UserRound,
  type LucideProps,
};
